import { baseApi } from '../../../apiHooks/baseApi';
import { dispatch } from '../../../state';

interface IResourceResponse {
    uuid: string;
    uri: string;
    account_uuid: string;
    type: string;
}

export interface IFrameIndexData {
    uri: string;
    id: string;
}

const iframeIndexApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
        getResourceForIframe: builder.query<
            IResourceResponse,
            { uri: string }
        >({
            query: (params) => ({
                url: '/resource/',
                params: { uri: params.uri },
            }),
        }),
    }),
});

export async function getIndex(requestPayload: Record<string, unknown>): Promise<IFrameIndexData> {
    const uri = requestPayload.uri as string | undefined;
    if (!uri || typeof uri !== 'string') {
        throw 'uri is required and must be a string';
    }

    const dispatchResult = dispatch(
        iframeIndexApi.endpoints.getResourceForIframe.initiate(
            { uri },
            { forceRefetch: true },
        ),
    );
    try {
        const resource = await dispatchResult.unwrap();
        if (resource.type !== 'index') {
            throw `Resource "${resource.uri}" is not an Index`;
        }
        return {
            uri: resource.uri,
            id: `${resource.account_uuid}.${resource.uuid}`.replaceAll('-', '_'),
        };
    } finally {
        dispatchResult.unsubscribe();
    }
}
